import { graphql, useFragment } from "react-relay";
import type { lessonBlocked_lesson$key } from "./__generated__/lessonBlocked_lesson.graphql";
import { Card } from "@/components/ui/card";
import { cn } from "@/utils";
import { format } from "date-fns";
import { Icon } from "@/components/icon";

export function LessonBlocked({
	lesson,
	availableAt,
	requiresPreviousLesson,
}: {
	lesson: lessonBlocked_lesson$key;
	availableAt?: Date;
	requiresPreviousLesson?: boolean;
}) {
	const data = useFragment<lessonBlocked_lesson$key>(
		graphql`
    fragment lessonBlocked_lesson on CourseClass {
      name
    }
  `,
		lesson,
	);

	const explanation = () => {
		if (requiresPreviousLesson) {
			return "Essa aula ainda não está disponível. Para acessá-la, você precisa primeiro completar as aulas anteriores.";
		}

		if (availableAt) {
			return `Essa aula só estará disponível a partir em ${format(availableAt, "dd/MM/yyyy 'às' HH:mm")}. Caso deseje mais informações, entre em contato com o administrador do curso.`;
		}

		return "Essa aula ainda não está disponível. Caso deseje mais informações, entre em contato com o administrador do curso.";
	};

	return (
		<div className="w-full flex flex-col gap-6">
			<Card className={cn("flex-1 w-full overflow-hidden h-fit pt-0")}>
				<div className="font-semibold text-2xl/6 mt-6 px-6 flex flex-row items-center justify-start gap-3">
					<div className="rounded-md bg-destructive text-destructive-foreground size-6 flex items-center justify-center">
						<Icon name="Lock" className="size-3" />
					</div>

					{data.name}
				</div>

				<div className="px-6 text-muted-foreground">{explanation()}</div>
			</Card>
		</div>
	);
}
